export default __webpack_public_path__ + "static/media/gallery_00.b1915d6a.jpg";